var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 9,
    viewBox: "0 0 25 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53238 7.668V9H0.450375V0.323999H2.06438V7.668H5.53238ZM8.30475 9H6.68475V0.323999H8.30475V9ZM17.6813 0.323999L14.1773 9H12.7193L9.21525 0.323999H10.5113C10.6513 0.323999 10.7653 0.358 10.8533 0.426C10.9413 0.494 11.0073 0.582 11.0513 0.689999L13.0973 5.982C13.1653 6.154 13.2293 6.344 13.2893 6.552C13.3533 6.756 13.4133 6.97 13.4693 7.194C13.5173 6.97 13.5693 6.756 13.6253 6.552C13.6813 6.344 13.7433 6.154 13.8113 5.982L15.8453 0.689999C15.8773 0.597999 15.9392 0.513999 16.0312 0.438C16.1273 0.362 16.2433 0.323999 16.3793 0.323999H17.6813ZM20.1993 1.608V4.014H23.2353V5.256H20.1993V7.71H24.0513V9H18.5793V0.323999H24.0513V1.608H20.1993Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/LIVE.dd22ff04eddc9617109169cef8c92b1e.svg";
export { ForwardRef as ReactComponent };